import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';
import { ProjectActions } from '../actions/project';
import { currentPageIdSelector, currentPageTypeSelector } from './projectTabs';

const projectActions = getActionIds(ProjectActions);

// import { currentElementTypeSelector } from './elementTypes';
// import { currentElementSelector } from './elements';

const initialState = Immutable.fromJS({
  icons: {},
  search: {},
  searchLoading: false,
  searchLoaded: false,
});

export const icons = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.getIcons.success]: (state, action) => {
    return state.mergeDeep({
      icons: action.result.icons,
    });
  },

  [projectActions.iconSearch.begin]: (state, action) => {
    return state
      .mergeDeep({
        searchLoading: true,
        searchLoaded: false,
      })
      .set('search', Immutable.fromJS({}));
  },

  [projectActions.iconSearch.failure]: (state, action) => {
    return state
      .mergeDeep({
        searchLoading: false,
        searchLoaded: false,
      })
      .set('search', Immutable.fromJS({}));
  },

  [projectActions.iconSearch.success]: (state, action) => {
    return state
      .mergeDeep({
        searchLoading: false,
        searchLoaded: true,
      })
      .set('search', Immutable.fromJS(action.result));
  },

  [projectActions.clearIconSearch]: (state, action) => {
    return state
      .mergeDeep({
        searchLoading: false,
        searchLoaded: false,
      })
      .set('search', Immutable.fromJS({}));
  },
});

export const getIcon = (currentElement, currentElementType, iconsState) => {
  if (currentElement.size === 0 && !currentElementType) return null;

  const elementIcon = iconsState.get(currentElement.get('icon_id'), null);
  const elementTypeIcon = iconsState.get(
    currentElementType.get('icon_id'),
    null,
  );

  return elementIcon || elementTypeIcon;
};

export const iconsSelector = state => state.icons.get('icons');

export const iconSelector = state => {
  const currentPageId = currentPageIdSelector(state);
  const currentPageType = currentPageTypeSelector(state);

  if (!currentPageId) return null;

  switch (currentPageType) {
    case 'report': {
      const reportIconId = state.reports.getIn(
        ['reports', currentPageId, 'icon_id'],
        null,
      );

      return state.icons.getIn(['icons', reportIconId], null);
    }
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/icons.js